import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import connect from 'components/lib/connect';
import { StyledAvatar } from './task_comment';

export function FakeCommentEditor({ agentAvatarUrl, agentName, className, hasThread, onClick }) {
  const { t } = useTranslation();

  return (
    <StyledEditorWrapper className={className} onClick={onClick}>
      <StyledAvatar noWrapper profile={{ name: agentName, image: agentAvatarUrl }} />
      <StyledCommentEditor
        data-aid="fakeCommentEditor"
        placeholder={hasThread ? t('Reply to this thread') : t('Comment on this task')}
        readOnly
      />
    </StyledEditorWrapper>
  );
}

const StyledCommentEditor = styled.input`
  background-color: ${p => p.theme.colors.white};
  border: 1px solid ${p => p.theme.colors.gray400};
  border-radius: ${p => p.theme.borderRadius.default};
  cursor: pointer;
  margin-left: ${p => p.theme.spacing.medium};
  outline: none;
  padding: 8px 12px;
  width: 100%;

  &:hover {
    background-color: ${p => p.theme.colors.white};
    border-color: ${p => p.theme.colors.green400};
    ::placeholder {
      color: ${p => p.theme.colors.green400};
    }
  }
`;

const StyledEditorWrapper = styled.div`
  display: flex;

  .profileAvatar {
    align-items: center;
    display: flex;
  }
`;

FakeCommentEditor.propTypes = {
  agentName: PropTypes.string,
  agentAvatarUrl: PropTypes.string,
  className: PropTypes.string,
  hasThread: PropTypes.bool,
  onClick: PropTypes.func,
};

function mapStateToProps({ getProvider }) {
  const agent = getProvider('currentAgent').get();

  return {
    agentName: agent && (agent.name || agent.email),
    agentAvatarUrl: agent && agent.avatarUrl,
  };
}

const FakeEditorContainer = connect(mapStateToProps)(FakeCommentEditor);
export default FakeEditorContainer;
